import creator from 'letter.meta';

const featuresHas = (name: string): boolean => name === 'payment-letter-pdf';

const letterMeta = (paymentInfo: EnteredPaymentInfo | null): void => {
	if (!paymentInfo) {
		return;
	}

	const Wrapper = creator({
		loadPath: '//img.imgsmail.ru/pkgs/letter.meta/2.5.0/ru_RU/',
		email: 'lolkek@mail.ru',
		isFake: true,
	});

	const containerElement = document.getElementById('container');

	if (!containerElement) {
		return;
	}

	const container = new Wrapper(document.getElementById('container'));

	const {
		amount,
		period,
		payer,
		address,
	} = paymentInfo;

	container.renderWrapper({
		model: {
			getJsonLdEvent: () => {},
			getPaymentMeta: () => ({
				skin: 'dataset',
				merchant_id: 'mosenergo',
				amount,
				period,
				payer,
				address,
				pdfLink: '',
				attachid: '15347622890000000768;0;1',
				link_receipt_paid: '',
				link_receipt: '',
				status: 'success',
				show: true,
				payment_url: 'lolkek',
				detailed_url: '',
			}),
			get: () => false,
		},
		flags: {
			get: () => false,
		},
		features: {
			has: featuresHas,
			get: () => false,
		},
		cfg: {
			get: () => false,
		},
	});
};

export default letterMeta;
